import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { AgentListFeatureGate } from '../Guards/AgentListFeatureGate'
import { AgentList } from '../Components/Organisms/AgentList/AgentList'

/**
 * Routed ACD Agents list page.
 */
@Route(RouteID.AGENT)
export class AgentListPage extends Component {
    /**
     * Renders the ACD Agents admin list page content tree.
     *
     * @returns ACD Agents list page tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.AGENT}>
                <AgentListFeatureGate>
                    <LanguageContextProvider>
                        <AgentList />
                    </LanguageContextProvider>
                </AgentListFeatureGate>
            </RouteGuard>
        )
    }
}
